import { render, staticRenderFns } from "./MobileResourceDrawer.vue?vue&type=template&id=6bf8ed65&"
import script from "./MobileResourceDrawer.vue?vue&type=script&lang=js&"
export * from "./MobileResourceDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports